// Shared attribute-name and style helpers used by both the client DOM-mutation path
// (`applyProp` in jsx-runtime.ts) and the server-string fallback path (`ssrAttrs`,
// also in jsx-runtime.ts) so the two stay in sync on which props get special-cased.

/** className -> class, htmlFor -> for, tabIndex -> tabindex; anything else unchanged. */
export function normalizeAttrName(key: string): string {
  if (key === 'className') return 'class';
  if (key === 'htmlFor') return 'for';
  if (key === 'tabIndex') return 'tabindex';
  return key;
}

/** True for event-handler props like `onClick`, `onMouseEnter` — camelCase after `on`. */
export function isEventProp(key: string): boolean {
  return key.startsWith('on') && key[2] === key[2]?.toUpperCase();
}

/** Convert a style object's entries to `[cssProperty, value]` pairs, camelCase -> kebab-case. */
export function styleEntriesToCss(style: Record<string, string | number>): [string, string][] {
  return Object.entries(style).map(([k, v]) => [
    k.replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`),
    String(v),
  ]);
}
